import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { PRO_COPY } from "../library/proCopy.js";
import type { ProFeature } from "../library/proFeatures.js";

/**
 * A whole page that is Pro only (Catch-up, Recordings, Remote control): what it is, and one button
 * that goes to where upgrading is done. Focus starts on that button, so a remote always has a
 * place to press, and Back leaves like on any page.
 */
export function ProLockedPanel({ feature }: { feature: ProFeature }) {
  const navigate = useNavigate();
  const button = useRef<HTMLButtonElement>(null);
  const copy = PRO_COPY[feature];

  useEffect(() => {
    button.current?.focus();
  }, []);

  return (
    <div className="page pro-locked">
      <h1 className="pro-locked__title">{copy.title}</h1>
      <p className="pro-locked__body">{copy.body}</p>
      <p className="pro-locked__offer">Upgrade to Pro: $1.99 a month, $9.99 a year or $24.99 once.</p>
      <button
        ref={button}
        type="button"
        className="ui-btn ui-btn--primary"
        onClick={() => navigate("/settings", { state: { focus: "licensing" } })}
      >
        See Pro
      </button>
    </div>
  );
}
